export default class Oauth2Config {
    constructor(
        public ClientID: string = "",
        public ClientSecretKey: string = "",
        public Scope: string = "",
        public Audience: string = "",
        public AuthenticationUrl: string = "",
    ) { }
}